'use client';

import { useCallback } from 'react';
import { useTranslation } from 'next-i18next';
import {
  Button,
} from '@components/common';
import { useCompanyJobActions } from '@components/templates/my-jobs/hooks/useCompanyJobActions';
import { ConversionConfirmationDialog } from '@components/templates/my-jobs/ConversionConfirmationDialog';

interface MyJobCardActionsProps {
  job: Partial<ApiSchema<'MyJobCard'>>;
  jobId?: number;
  defaultConversionPackageId?: string;
  revalidate?: (jobSlug: string, oldStatus: string, newStatus: string) => void;
}


export const ConversionButton = (props: MyJobCardActionsProps) => {
  const {
    job, revalidate, jobId = 0, defaultConversionPackageId = '',
  } = props;
  const { t } = useTranslation('common');

  const revalidateJob = useCallback((newStatus: string) => {
    revalidate?.(job.slug!, job.state!, newStatus);
  }, [revalidate, job]);

  const {
    handleConversionCalculatePrice,
    isConvertConfirmationOpen,
    handleConvertConfirm,
    handleConvertCancel,
    conversionPriceDetails,
    isConversionCalculatingPrice,
    isConvertToPaid,
  } = useCompanyJobActions({
    jobSlug: job.slug!,
    jobId,
    currentJobState: job.state,
    defaultConversionPackageId,
    onSuccessConversionCalculatePrice: () => {
      revalidateJob?.(job.state ?? 'active');
    },
    onSuccessConvert: () => {
      revalidateJob?.(job.state ?? 'active');
    },
  });

  return (
    <>
      <div className="flex items-center gap-2">
        <Button
          styling="none"
          size="sm"
          className="mt-2 flex gap-2 text-left text-sm text-info hover:underline"
          aria-label={t('my-jobs.card.actions.conversion.eligible')}
          onClick={() => { void handleConversionCalculatePrice(); }}
          spinnerClass="size-6"
          isLoading={isConversionCalculatingPrice}
        >
          {t('my-jobs.card.actions.conversion.eligible')}
        </Button>
      </div>

      <ConversionConfirmationDialog
        open={isConvertConfirmationOpen}
        conversionPriceDetails={conversionPriceDetails}
        onConfirm={handleConvertConfirm}
        onCancel={handleConvertCancel}
        isConfirmLoading={isConvertToPaid}
      />
    </>
  );
};
